/**
 * Секунды в «чч:мм:сс» с обязательными часами (00:10:14), чтобы колонка
 * читалась однозначно. Общий `formatDuration` для коротких видео отдаёт
 * «10:14», что в списке хранилища путается с минутами:секундами.
 */
export function formatClock(seconds: number): string {
  const total = Math.max(0, Math.round(seconds));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  const pad = (value: number) => String(value).padStart(2, "0");
  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
}
